import {
  Fingerprint, SendHorizontal, Receipt, CreditCard, Workflow, Store,
  Landmark, Banknote, Smartphone, ShieldCheck, Zap, Globe, QrCode, Wallet,
  Leaf, BadgeCheck, Award, HeartHandshake, Plane, TrainFront,
} from "lucide-react";

export const ICONS = {
  Fingerprint, SendHorizontal, Receipt, CreditCard, Workflow, Store,
  Landmark, Banknote, Smartphone, ShieldCheck, Zap, Globe, QrCode, Wallet,
  Leaf, BadgeCheck, Award, HeartHandshake, Plane, TrainFront,
};

export const ICON_OPTIONS = Object.keys(ICONS);
